import { useEffect, useState } from 'react'

import { usePrevious } from '@fourthwall/components'

import type { VariantTypes } from '../../../SingleProduct.types'
import type { OfferImagesFilter } from '../types'

type UseOfferImagesFilters = (variantTypes: VariantTypes | undefined) => OfferImagesFilter[]

type State = Record<string, string>

export const useOfferImagesFilters: UseOfferImagesFilters = (variantTypes) => {
  const [state, setState] = useState<State>({})
  const previousVariantTypesLength = usePrevious(variantTypes ? variantTypes.length : 0)

  useEffect(() => {
    if (!variantTypes) return

    if (variantTypes.length === previousVariantTypesLength) return

    const newState = variantTypes.reduce<State>(
      (previous, current) => ({ ...previous, [current.type]: current.options[0].id }),
      {},
    )

    setState(newState)
  }, [variantTypes, previousVariantTypesLength])

  const getFilterValue = (key: string): string => {
    return state[key]
  }

  const setFilterValue = (key: string) => (value: string) => {
    return setState((current) => ({ ...current, [key]: value }))
  }

  const filters = variantTypes
    ? variantTypes
        .filter((variantType) => variantType.variesBy.imagery)
        .map<OfferImagesFilter>((variantType) => ({
          type: variantType.type === 'COLOR' ? 'COLOR' : 'SELECT',
          tag: variantType.type,
          label: variantType.title,
          options: variantType.options.map((option) => ({
            label: option.name,
            value: option.id,
            color: option.colorSwatch || '',
          })),
          value: getFilterValue(variantType.type),
          onChange: setFilterValue(variantType.type),
        }))
    : []

  return filters
}
